import Hero from 'components/ckan/Herov2.jsx'
import SocialProof from 'components/ckan/SocialProof.jsx'
import DynamicIntro from 'components/ckan/DynamicIntro.jsx'
import Highlight1 from 'components/ckan/Highlight1.jsx'
import Highlight2 from 'components/ckan/Highlight2.jsx'
import Highlight3 from 'components/ckan/Highlight3.jsx'
import ValuePropositions from 'components/ckan/ValuePropositions.jsx'
import Features from 'components/ckan/Features.jsx'
import Grid from 'components/ckan/Grid.jsx'
import Contact from 'components/ckan/Contact.jsx'
import Contact2 from 'components/ckan/Contact2.jsx'
import MoreFeatures from 'components/ckan/MoreFeatures.jsx'
import Faq from 'components/ckan/ckan/Faq.jsx'


export default function Index() {
  const featured = [
    {
      title: "User-friendly Interface",
      text: "Say goodbye to frustration. Navigate and explore your data with ease.",
      icon: "/assets/icons/ebook.json",
    },
    {
      title: "Drag-and-drop Feature",
      text: "Our drag-and-drop feature makes it easy for anyone to publish open data, regardless of skill",
      icon: "/assets/icons/click.json",
    },
    {
      title: "Advanced Data Visualization",
      text: "Empower your users to uncover insights and trends in your open data with our powerful self-service visualization tools.",
      icon: "/assets/icons/flow-chart.json",
    },
    {
      title: "Quick Insights",
      text: "Make your data come alive with our beautiful charts and quick insights - showcasing your best datasets has never been easier.",
      icon: "/assets/icons/bar-chart-2.json",
    },
    {
      title: "CKAN-based",
      text: "Get the best features from CKAN. Perfect for organizations looking for a lightweight and cost-effective solution.",
      icon: "/assets/icons/layers.json",
    },
    {
      title: "SaaS Experience",
      text: "Get more done, with less hassle without worrying about maintenance and support. On our cloud or yours. You choose.",
      icon: "/assets/icons/cloud-network.json",
    },
  ]

  const values = [
    {
      title: "Ready to go out of the box",
      text: "CKAN lets you get a working data solution up and running in minutes. Create a base product quickly and start extending and customizing it as you go.",
    },
    {
      title: "Super customizable",
      text: "Too many companies spend thousands adjusting their processes to fit a new technology. CKAN works around your existing workflows and systems.",
    },
    {
      title: "Free to use",
      text: "Avoid vendor lock-in and expensive upgrades with open-source software. CKAN is aimed at those looking for a sustainable data management strategy.",
    },
  ]
  return (
    <div className="!overflow-x-hidden">
      <section className='bg-homeWork bg-cover bg-no-repeat bypass-filter bg-ckanPosition'>
        <div className="flex flex-wrap justify-center">
          <div className="max-w-7xl w-full relative">
            <Hero
              topTitle="CKAN"
              title="The world's most trusted open-source data management software."
              subtitle="Build everything from open data portals to enterprise data catalogs."
              ctaOffer="See other offerings" ctaUrl="/solutions" />
          </div>
        </div>

        <SocialProof />
        <DynamicIntro />
      </section>
      <div className="flex flex-wrap justify-center bg-transparent">
        <div className="max-w-7xl w-full">
          <Highlight1 />
          <Highlight2 reverse />
          <Highlight3 />
          <ValuePropositions topTitle="What makes CKAN the leading data management software?" title="CKAN is usable both ‘out of the box’ and as a powerful framework for creating more tailored systems. CKAN’s combination of open-source codebase and enterprise support make it uniquely attractive for organizations looking to build customized, enterprise- or government-grade solutions." valuePropositions={values} />
          <MoreFeatures />
        </div>
        <Features topTitle="All the features you need" title="CKAN provides a wide range of features for data management, including data cataloguing, data governance, data quality control, data workflows, and data backup and recovery." featuredItems={featured} />
        <div className="max-w-7xl w-full" id="services">
          <Grid />
          <Faq />
        </div>
        <Contact />
        <div className="md:hidden" aria-hidden={true}>
          <Contact2 />
        </div>
      </div>
    </div>
  )
}